import { create } from 'zustand'

export type ActiveDialog = null | 'new-channel' | 'new-group' | 'new-dm'

interface UiState {
  dialog: ActiveDialog
  openDialog: (dialog: Exclude<ActiveDialog, null>) => void
  closeDialog: () => void
  /** The bot whose profile is open (its user id). */
  botProfile: string | null
  openBotProfile: (userId: string) => void
  closeBotProfile: () => void
  /** A conversation chosen to leave from the list, waiting to be confirmed. */
  leaving: { channelId: string; name: string } | null
  confirmLeave: (channelId: string, name: string) => void
  closeLeave: () => void
}

export const useUi = create<UiState>((set) => ({
  dialog: null,
  openDialog: (dialog) => set({ dialog }),
  closeDialog: () => set({ dialog: null }),
  botProfile: null,
  openBotProfile: (userId) => set({ botProfile: userId }),
  closeBotProfile: () => set({ botProfile: null }),
  leaving: null,
  confirmLeave: (channelId, name) => set({ leaving: { channelId, name } }),
  closeLeave: () => set({ leaving: null }),
}))
